import React from 'react';
import { Form, Select, Tooltip } from 'antd';
import { LICENSE_TYPES } from '../../../services/licenseService';

const { Option } = Select;

const LicenseTypeField = ({ form, isEdit, onTypeChange }) => {
  return (
    <Form.Item
      label={
        <Tooltip title="Type of license activation">
          <span>License Type</span>
        </Tooltip>
      }
      name="license_type"
      rules={[{ required: true, message: 'Please select a license type' }]}
    >
      <Select 
        disabled={isEdit}
        placeholder="Select license type"
        onChange={onTypeChange}
      >
        <Option value={LICENSE_TYPES.SUBSCRIPTION}>Subscription</Option>
        <Option value={LICENSE_TYPES.PERPETUAL}>Perpetual</Option>
      </Select>
    </Form.Item>
  );
};

export default LicenseTypeField;
